<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">查看模板</div>
    <div class="third-title"><span>模板信息</span></div>
    <div class="order-detail-basic">
      <el-form ref="form" v-for="page in templateGroupList" :key='page.groupId + page.pageTypeCode' :model="{ templateGroupList }" label-width="150px">
        <el-form-item :label="page.pageTypeCode === 'COVER' ? '封面模板规格：' : page.pageTypeCode === 'TEXT' ? '内页模板规格：' : page.pageTypeCode === 'SINGLE' ? '单页模板规格：' : '未定义'"> {{ page.sizeWidth + 'x' +
          page.sizeHeight + 'mm' }} </el-form-item>
        <el-form-item :label="page.pageTypeCode === 'COVER' ? '封面模板数量：' : page.pageTypeCode === 'TEXT' ? '内页模板数量：' : page.pageTypeCode === 'SINGLE' ? '单页模板数量：' : '未定义'"> {{ page.groupVos.length }}
        </el-form-item>
        <el-form-item :label="page.pageTypeCode === 'COVER' ? '封面模板：' : page.pageTypeCode === 'TEXT' ? '内页模板：' : page.pageTypeCode === 'SINGLE' ? '单页模板：' : '未定义'">
          <el-button type="primary" @click="add(page)" round>关联</el-button> <span>拖动修改模板顺序</span>
          <div class="imgbox">
            <draggable v-model="page.groupVos" chosenClass="chosen" forceFallback="true" group="people" animation="1000">
              <transition-group style="display: flex;flex-direction: row;flex-wrap:wrap;">
                <div v-for="(group, index) in page.groupVos" :key='group.id' style="width:170px;margin:5px 5px 0 0;display:flex;flex-direction: column;justify-content: space-between;">
                  <templateThumbnail :templateGroup="group" />
                  <p style="text-align:center;border:1px solid #000;border-top:none;cursor: pointer;" @click="page.groupVos.splice(index, 1), $forceUpdate()">删除 </p>
                </div>
              </transition-group>
            </draggable>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="saveTemplateGourpMsg" v-preventReClick>确定</el-button>
    </div>
    <!-- 关联模板 -->
    <el-dialog :close-on-click-modal="false" title="关联模板" :visible.sync="addFormatDialog" width="75%">
      <el-form :inline="true" :model="searchTemplateVo" class="demo-form-inline">
        <el-form-item label="设计人员:">
          <el-input v-model="searchTemplateVo.createdName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="模板主题:">
          <el-select clearable v-model="searchTemplateVo.templateThemeId" placeholder="">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value1" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="模板性质:">
          <el-select clearable v-model="searchTemplateVo.propertyId" placeholder="">
            <el-option v-for="item in FormatPropertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面类型:">
          <span>{{ searchTemplateVo.pageTypeCode === 'COVER' ? '封面' : searchTemplateVo.pageTypeCode === 'TEXT' ? '内页' : searchTemplateVo.pageTypeCode === 'SINGLE' ? '单页' : '' }}</span>
        </el-form-item>
        <el-form-item label="宽高:">
          <span>{{ searchTemplateVo.templateSize }}</span>
        </el-form-item>
        <el-form-item label="照片数量:">
          <el-input v-model="searchTemplateVo.imageCout" placeholder=""></el-input>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button @click="searchFormatList()" round>查询</el-button>
          <el-button type="primary" @click="addFormat" round v-preventReClick>关联</el-button>
        </div>
      </el-form>
      <el-table :data="formatList" @selection-change="handleFormatSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column label="模板页缩略图">
          <template slot-scope="scope">
            <div class="imgBox">
              <div class="img">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" :src="scope.row.templateThumbnailList[0]" fit="fill"></el-image>
              </div>
              <div class="img" v-if="scope.row.propertyId !== 2">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" :src="scope.row.templateThumbnailList[1]" fit="fill"></el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="页面类型">
          <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
        </el-table-column>
        <el-table-column prop="propertyName" label="性质">
          <template slot-scope="scope"> {{ propertyObj[scope.row.propertyId] }} </template>
        </el-table-column>
        <el-table-column prop="imageCount" label="照片数量"></el-table-column>
        <el-table-column prop="templateSize" label="宽高"></el-table-column>
        <el-table-column prop="createdName" label="设计人员"></el-table-column>
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changeFormatPage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
  </div>
</template>
<script>
import templateThumbnail from '@/components/templateThumbnail.vue'

import VPagination from '@/components/Pagination/index.vue'
import draggable from 'vuedraggable'
import { groupQueryGroupById, storeGetStoreList, composeGroupDetail, getTemplateListByGroupId, updateGroupXrefTemplate, groupGetStoreListByGroupId, groupUpdate, propertyGetPropertyList, templateGroupGetTemplateGroupList, sampleListNoPaging } from '@/api/pms'
import { storeTypeGetStoreTypeList } from '@/api/crm'
export default {
  name: 'add-hemorrhage',
  components: {
    draggable, VPagination, templateThumbnail
  },
  data () {
    return {
      selectStoreList: [],
      storeList: [],
      value1: [],
      storeTypeList: [],
      addStoreDialog: false,
      addSkuDialog: false,
      addFormatDialog: false,
      templateGroupList: {},
      searchStoreVo: {
        code: '',
        createTimeBegin: '',
        createTimeEnd: '',
        id: '',
        name: '',
        page: 1,
        storeType: '',
        storeTypeid: ''
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 6
      },
      searchTemplateVo: {
        createdName: '',
        auditStatus: 'AUDITED',
        createTimeBegin: '',
        createTimeEnd: '',
        imageCout: '',
        page: 1,
        pageTypeCode: '',
        propertyId: '',
        templateSize: '',
        templateThemeId: ''
      },
      sampleList: [],
      FormatPropertyList: [],
      propertyObj: {},
      formatList: [],
      selectFormatList: [],
      textPageNum: ''
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getTemplateGroupMsg()
    this.getFormatSampleList()
    this.getFormatPropertyList()
    this.getStoreListByGroupId()
    if (this.$route.query.maxPage) {
      this.$route.query.maxPage.forEach(item => {
        if (item.typeName === '内页') {
          this.textPageNum = item.templateGroupNum
        }
      })
    }
  },
  watch: {
    value1 (val) {
      this.searchTemplateVo.createTimeBegin = val === null ? '' : val[0]
      this.searchTemplateVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  methods: {
    // 准备添加关联
    add (item) {
      this.searchTemplateVo.templateSize = item.sizeWidth + 'x' + item.sizeHeight + 'mm'
      this.searchTemplateVo.pageTypeCode = item.pageTypeCode
      // this.searchTemplateVo.pageTypeId = item.pageTypeId
      this.queryInfo.pageNum = 1
      this.$forceUpdate()
      this.addFormatDialog = true
      this.searchFormatList()
    },
    // 编辑模板
    saveTemplateGourpMsg () {
      let templateXrefVos = {
        change: true,
        id: +this.$route.query.id,
        textPageNum: 0,
        templateXrefVos: [
        ]
      }
      // if (this.templateGroupList.groupBelong === 1) {
      //   this.storeList.forEach(item => {
      //     templateXrefVos.storeIds.push(item.storeId)
      //   });
      // }
      this.templateGroupList.forEach(item => {
        let obj = {
          pageTypeCode: item.pageTypeCode,
          templateGroups: []
        }
        item.groupVos.forEach((group, index) => {
          obj.templateGroups.push({
            sorting: index + 1,
            templateGroupId: group.id
          })
        })
        templateXrefVos.templateXrefVos.push(obj)
      })
      let TEXTNUM = 0
      let SINGLENUM = 0
      templateXrefVos.templateXrefVos.forEach(k => {
        // if (k.pageTypeCode === 'TEXT') {
        //   templateXrefVos.textPageNum = k.templateGroups.length
        // }
        if (k.pageTypeCode === 'TEXT') {
          TEXTNUM = k.templateGroups.length
        }
        if (k.pageTypeCode === 'SINGLE') {
          SINGLENUM = k.templateGroups.length
        }
        templateXrefVos.textPageNum = TEXTNUM + SINGLENUM
      })
      updateGroupXrefTemplate(templateXrefVos).then(res => {
        if (res.data.success) {
          this.$message.success('编辑成功')
          this.$router.go(-1)
        }
      })
    },
    // 获取模板组归属平台
    getStoreListByGroupId () {
      groupGetStoreListByGroupId({ pageNum: 1, pageSize: 10, searchStoreVo: { groupId: this.$route.query.id, page: 0 } }).then(res => {
        if (res.data.success) {
          this.storeList = res.data.data.records
        }
      })
    },
    // 关联模板
    addFormat () {
      this.templateGroupList.forEach(item => {
        if (item.pageTypeCode === this.searchTemplateVo.pageTypeCode) {
          // item.templates = this.selectFormatList
          this.selectFormatList.forEach(tem => {
            let repetition = true
            item.groupVos.forEach(val => {
              if (val.id === tem.id) {
                repetition = false
              }
            })
            if (repetition) {
              item.groupVos.push(tem)
            }
          })
        }
      })
      this.addFormatDialog = false
    },
    // 获取模板性质
    getFormatPropertyList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyObj = res.data.data.reduce((obj, item) => {
            obj[item.id] = item.propertyName
            return obj
          }, {})
          this.FormatPropertyList = res.data.data
        }
      })
    },
    // 获取模板主题
    getFormatSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.sampleList = res.data.data
        }
      })
    },
    // 获取模板列表
    searchFormatList () {
      templateGroupGetTemplateGroupList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchTemplateVo: this.searchTemplateVo }).then(res => {
        if (res.data.success) {
          let obj = res.data.data.records

          obj.forEach(item => {
            if (item.propertyId === 2) {
              item.templateThumbnailList = [item.templates[0]?.templateThumbnail]
            } else {
              item.templateThumbnailList = item.templates.reduce((list, temp) => {
                list[temp.templatePosition] = temp?.templateThumbnail
                return list
              }, [])
            }
          })

          this.formatList = obj

          this.queryInfo.total = res.data.data.total
        }
      })
    },
    getTemplateGroupMsg () {
      getTemplateListByGroupId(this.$route.query.id).then(res => {
        if (res.data.success) {
          let list = res.data.data
          list.forEach(page => {
            page.groupVos.forEach((group, ind) => {
              if (group.propertyId === 2) {
                console.log(group.propertyId, 'group.templates ' + ind, group.templates)
                group.templateThumbnailList = [group.templates[0]?.templateThumbnail]
              } else {
                group.templateThumbnailList = group.templates.reduce((list, temp) => {
                  console.log(temp.templatePosition)
                  list[temp.templatePosition] = temp?.templateThumbnail
                  return list
                }, [])
              }
            })
          })
          console.log(list)
          this.templateGroupList = list
        }
      })
    },
    handleFormatSelectionChange (val) {
      this.selectFormatList = val
    },
    changeFormatPage (val) {
      console.log('val', val)
      this.queryInfo = val
      this.searchFormatList()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}

.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
  }
}
</style>
